<template>
  <div class="modal" v-show="isOpen" >
    <div ref="modalBody" class="modal-body">
      <div ref="modalInner" class="modal-inner">
        <div class="modal-header">
          <div class="modal-title">
            <h3 class="main-title">{{ title }}</h3>
            <p v-if="description" class="modal-description">
            {{ description }}
            </p>
           </div>
          <div class="modal-close" @click="$emit('close')">&times;</div>
        </div>
        <div class="modal-content modalScroll" :class="{ 'modal-scroll': scroll }" >
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isOpen: false,
      resizeObserver: null
    }
  },
  watch: {
    open () {
      this.isOpen = this.open
      if (this.isOpen) {
        this.$nextTick(() => {
          this.updateModalHeight()
        })
      }
    }
  },
  methods: {
    chieckOutsideClick (e) {
      if (this.closeOnOutsideClick && e.target === this.$el) {
        this.$emit('close')
      }
    },
    closeOnEscapeKey (event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.$emit('close')
      }
    },
    updateModalHeight () {
      const modalBody = this.$refs.modalBody
      const modalInner = this.$refs.modalInner
      if (!modalBody || !modalInner) {
        return
      }
      const nextHeight = modalInner.scrollHeight
      const currentHeight = modalBody.getBoundingClientRect().height
      if (Math.round(currentHeight) === Math.round(nextHeight)) {
        return
      }
      modalBody.style.height = `${currentHeight}px`
      // modalBody.offsetHeight
      modalBody.style.height = `${nextHeight}px`
    }
  },
  mounted () {
    document.addEventListener('keydown', this.closeOnEscapeKey)
    if (this.closeOnOutsideClick) {
      this.$el.addEventListener('mousedown', this.chieckOutsideClick)
    }
    if (window.ResizeObserver && this.$refs.modalInner) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateModalHeight()
      })
      this.resizeObserver.observe(this.$refs.modalInner)
    }
    this.$nextTick(() => {
      this.updateModalHeight()
    })
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.closeOnEscapeKey)
    if (this.closeOnOutsideClick) {
      this.$el.removeEventListener('mousedown', this.chieckOutsideClick)
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  }
}
</script>

<style lang="scss" scoped >
.modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 4;
  background-color: rgba(0,0,0,0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  &-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  }
  &-description {
  margin: 0;
  padding: 0;
  font-size: var(--text-s);
  font-weight: 150;
  opacity: 1;
  color: #616569;
  line-height: 1.4;
  }
  &-body {
    position: relative;
    box-shadow: 0 0 2px var(--brand-color);
    border-radius: 8px;
    animation: popIn 0.1s ease-in;
    // background: var(--bg-color);
    background: var(--white);
    transition: height 0.24s ease;
    overflow: hidden;
    max-width: 80vw;
    max-height: 99vh;
  }
  &-inner {
    padding: 23px 20px 20px 20px;
  }
  &-close {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: var(--text-3xl);
    color: rgba(59, 59, 59, 0.4666666667);
    cursor: pointer;
    transition: opacity 0.2s;
  }
  &-close:hover {
    opacity: 0.6;
  }
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 12px;
    text-align: center;
    border-bottom: 1px solid #d1d5db;
  }
  &-header h3 {
    margin: 0;
    padding-right: 6rem;
    font-size: var(--text-base);
    font-weight: 400;
    color: var(--text-color-1);
  }
  &-content {
    padding: 10px 10px 0 10px;
    // background-color: var(--bg-color);
    background-color: var(--white);
    max-height: 85vh;
    overflow: auto;
    &-scroll {
      overflow-y: auto;
    }
  }
  @keyframes popIn {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
